// extracted by css-extract-rspack-plugin
export default {"categoryPill":"product-listing-fragment__CategoryPill_categoryPill__t2Xab"};